import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const BlogHero = styled.section`
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 36px auto 18px;
  padding: 34px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  background:
    linear-gradient(135deg, rgba(238, 247, 245, 0.96) 0%, rgba(255, 250, 239, 0.96) 52%, rgba(246, 241, 255, 0.9) 100%);
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);

  @media (max-width: 768px) {
    padding: 20px;
    margin-top: 22px;
  }
`;

export const BlogHeroEyebrow = styled.p`
  margin: 0 0 10px;
  color: #0f766e;
  font-size: 0.95rem;
  font-weight: 800;
`;

export const MainTitle = styled.h1`
  width: 100%;
  margin: 0;
  color: #172033;
  font-size: 2.5rem;
  line-height: 1.18;
  text-align: left;
  overflow-wrap: anywhere;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const BlogMetaText = styled.p`
  margin: 14px 0 0;
  color: #475569;
  font-size: 1.05rem;
  line-height: 1.7;
`;

export const BlogHeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 22px;
  max-width: 100%;

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 44px;
    padding: 0 18px;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 999px;
    background: #0f766e;
    color: #ffffff;
    font-weight: 800;
    text-decoration: none;
    transition: background 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;

    &:hover {
      background: #115e59;
      transform: translateY(-2px);
      box-shadow: 0 12px 24px rgba(15, 118, 110, 0.2);
    }
  }

  @media (max-width: 420px) {
    a {
      width: 100%;
      padding: 0 14px;
      white-space: normal;
    }
  }
`;

export const BlogContainer = styled.div`
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 22px auto 44px;
  background: rgba(255, 255, 255, 0.96);
  padding: 34px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  @media (max-width: 768px) {
    padding: 18px;
    margin: 18px auto 32px;
  }
`;

export const SubTitle = styled.h2`
  margin: 0 0 20px;
  color: #172033;
  font-size: 1.65rem;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.45rem;
  }
`;

export const BlogToolbar = styled.div`
  display: grid;
  gap: 16px;
  margin-bottom: 26px;
`;

export const SearchInputWrap = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  min-height: 50px;
  padding: 0 16px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #64748b;
`;

export const SearchInput = styled.input`
  width: 100%;
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #172033;
  font-size: 1rem;

  &::placeholder {
    color: #94a3b8;
  }
`;

export const CategoryFilter = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const CategoryButton = styled.button`
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid ${({ $active }) => ($active ? '#0f766e' : '#d6dbe3')};
  border-radius: 999px;
  background: ${({ $active }) => ($active ? '#e6f5f2' : '#ffffff')};
  color: ${({ $active }) => ($active ? '#115e59' : '#475569')};
  cursor: pointer;
  font-weight: 700;
  transition: background 0.18s ease, border-color 0.18s ease, transform 0.18s ease;

  &:hover {
    border-color: #0f766e;
    transform: translateY(-1px);
  }
`;

export const PostGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const PostList = styled(PostGrid)``;

export const PostCard = styled(Link)`
  display: flex;
  min-width: 0;
  box-sizing: border-box;
  min-height: 260px;
  flex-direction: column;
  gap: 12px;
  padding: 20px;
  border: 1px solid rgba(15, 23, 42, 0.09);
  border-radius: 8px;
  background: #ffffff;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;

  &:hover {
    border-color: rgba(15, 118, 110, 0.5);
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.1);
    transform: translateY(-3px);
  }
`;

export const PostListTitle = styled.h3`
  margin: 0;
  color: #172033;
  font-size: 1.22rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
`;

export const PostExcerpt = styled.p`
  margin: 0;
  color: #526073;
  font-size: 1rem;
  line-height: 1.7;
`;

export const PostDate = styled.span`
  display: block;
  color: #64748b;
  font-size: 0.95rem;
`;

export const PostCardFooter = styled.div`
  display: grid;
  gap: 10px;
  margin-top: auto;
`;

export const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const TagPill = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 9px;
  border-radius: 999px;
  background: #f1f5f9;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 800;
`;

export const NumberBadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
`;

export const NumberBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff7df;
  color: #7c4a03;
  font-size: 0.95rem;
  font-weight: 900;
  box-shadow: inset 0 0 0 1px rgba(180, 120, 16, 0.2);
`;

export const EmptyState = styled.div`
  display: grid;
  box-sizing: border-box;
  gap: 16px;
  justify-items: start;
  padding: 24px;
  border: 1px dashed #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;

  p {
    margin: 0;
    color: #475569;
    line-height: 1.7;
  }

  a {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    min-height: 42px;
    padding: 0 16px;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 999px;
    background: #0f766e;
    color: #ffffff;
    font-weight: 800;
    text-decoration: none;
  }

  @media (max-width: 420px) {
    a {
      width: 100%;
      justify-content: center;
      white-space: normal;
    }
  }
`;

export const BlogTitle = styled.p`
  width: 100%;
  max-width: 1080px;
  box-sizing: border-box;
  margin: 34px auto 14px;
  color: #172033;
  font-size: 2rem;
  font-weight: 900;
  line-height: 1.25;
  cursor: pointer;
  transition: color 0.18s ease;

  &:hover {
    color: #0f766e;
  }

  @media (max-width: 768px) {
    margin-top: 22px;
    font-size: 1.7rem;
  }
`;

export const ArticleHeader = styled.header`
  display: grid;
  gap: 16px;
  max-width: 820px;
  margin: 0 auto 26px;

  h1 {
    margin: 0;
    color: #172033;
    font-size: 2.15rem;
    line-height: 1.32;
    overflow-wrap: anywhere;
  }

  ${NumberBadgeList} {
    margin-top: 2px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 1.75rem;
    }
  }
`;

export const SummaryBox = styled.p`
  box-sizing: border-box;
  margin: 0;
  padding: 18px 20px;
  border-left: 4px solid #0f766e;
  border-radius: 8px;
  background: #eef7f5;
  color: #334155;
  font-size: 1.02rem;
  line-height: 1.75;
`;

export const TocBox = styled.nav`
  box-sizing: border-box;
  max-width: 820px;
  margin: 0 auto 28px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;

  strong {
    display: block;
    margin-bottom: 10px;
    color: #172033;
  }

  div {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  a {
    color: #0f766e;
    font-weight: 800;
    text-decoration: none;
    padding: 6px 8px;
    border-radius: 6px;

    &:hover {
      background: #e6f5f2;
    }
  }
`;

export const BlogSection = styled.section`
  margin: 2rem 0;
  line-height: 1.8;
  color: #444;
`;

export const SectionTitle = styled.h3`
  margin: 1.5rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #f0f0f0;
  color: #333;
  font-size: 1.5rem;
`;

export const PostTitle = styled.h2`
  margin: 0 0 2rem;
  color: #333;
  font-size: 2rem;
  line-height: 1.35;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 1.7rem;
  }
`;

export const BlogMedia = styled.div`
  width: 100%;
  margin: 2rem 0;
  text-align: center;
`;

export const MediaLink = styled.a`
  display: inline-block;
  position: relative;
  max-width: 100%;
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);

    &::after {
      content: '자세히 보기';
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.72);
      color: white;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 14px;
    }

    img {
      filter: brightness(0.9);
    }
  }

  img,
  video {
    max-width: 700px;
    width: 100%;
    height: auto;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    object-fit: contain;
    transition: filter 0.3s ease;
  }

  .gif-media {
    background: #f8f8f8;
  }
`;

export const ImageCaption = styled.p`
  margin-top: 0.5rem;
  color: #666;
  font-size: 0.9rem;
  text-align: center;
`;

export const RelatedPostsSection = styled.section`
  max-width: 820px;
  margin: 42px auto 0;
  padding-top: 28px;
  border-top: 1px solid #e2e8f0;

  h2 {
    margin: 0 0 16px;
    color: #172033;
    font-size: 1.35rem;
    line-height: 1.35;
  }
`;

export const RelatedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const RelatedCard = styled(Link)`
  display: grid;
  min-width: 0;
  box-sizing: border-box;
  gap: 8px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  color: inherit;
  text-decoration: none;
  transition: border-color 0.18s ease, transform 0.18s ease;

  span {
    color: #0f766e;
    font-size: 0.86rem;
    font-weight: 900;
  }

  strong {
    color: #172033;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  &:hover {
    border-color: #0f766e;
    transform: translateY(-2px);
  }
`;

export const RelatedPostsTitle = styled.h4`
  margin-bottom: 1.5rem;
  color: #333;
  font-size: 1.3rem;
  text-align: center;
`;

export const RelatedPostsTable = styled.table`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  border-collapse: collapse;

  td {
    padding: 12px 15px;
    border-bottom: 1px solid #f0f0f0;
  }

  a {
    display: block;
    color: #333;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: #0f766e;
    }
  }
`;

export const PostContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: 820px;
  margin: 0 auto;
  color: #334155;
  font-size: 1.08rem;
  line-height: 1.78;

  p {
    margin: 0 0 1em;
  }

  a,
  ul,
  ol,
  li,
  table,
  th,
  td {
    font-size: 1rem;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: #172033;
    line-height: 1.35;
    overflow-wrap: anywhere;
  }

  h2 {
    margin: 2.2rem 0 1rem;
    font-size: 1.75rem;
  }

  h3 {
    margin: 2rem 0 0.9rem;
    font-size: 1.38rem;
  }

  h4 {
    margin: 1.4rem 0 0.65rem;
    font-size: 1.12rem;
  }

  .dream-cta-box {
    display: grid;
    box-sizing: border-box;
    max-width: 100%;
    justify-items: center;
    gap: 14px;
    margin: 30px 0;
    padding: 22px;
    border: 1px solid #d8efe9;
    border-radius: 8px;
    background: linear-gradient(135deg, #eef7f5 0%, #fff8e6 100%);
    text-align: center;
  }

  .dream-cta-box p {
    max-width: 620px;
    margin: 0;
    color: #475569;
  }

  .dream-cta-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 0 22px;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 999px;
    background: #0f766e;
    color: #ffffff;
    font-weight: 900;
    text-decoration: none;
    transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
  }

  .dream-cta-button:hover {
    background: #115e59;
    box-shadow: 0 12px 26px rgba(15, 118, 110, 0.22);
    transform: scale(1.035);
  }

  .lotto-number-row {
    display: flex;
    flex-wrap: wrap;
    gap: 9px;
    margin: 14px 0 22px;
  }

  .lotto-number-row span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: #fff7df;
    color: #7c4a03;
    font-weight: 900;
    box-shadow: inset 0 0 0 1px rgba(180, 120, 16, 0.2);
  }

  .table-responsive {
    width: 100%;
    overflow-x: auto;
    margin: 16px 0 26px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
  }

  table {
    width: 100%;
    min-width: 560px;
    border-collapse: collapse;
    background: #ffffff;
  }

  th,
  td {
    padding: 13px 14px;
    border-bottom: 1px solid #e2e8f0;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #f8fafc;
    color: #172033;
    font-weight: 900;
  }

  tr:last-child td {
    border-bottom: 0;
  }

  @media (max-width: 768px) {
    font-size: 1rem;

    h2 {
      font-size: 1.45rem;
    }

    h3 {
      font-size: 1.22rem;
    }

    .dream-cta-box {
      padding: 18px;
    }

    .dream-cta-button {
      width: 100%;
      padding: 0 14px;
      white-space: normal;
      text-align: center;
    }
  }

  .lotto-explainer-link {
    display: grid;
    gap: 8px;
    margin: 26px 0;
    color: #0f766e;
    font-size: 0.9rem;
    font-weight: 800;
    text-align: center;
    text-decoration: none;
  }

  .lotto-explainer-link img {
    display: block;
    width: 100%;
    height: auto;
    border: 1px solid #d8efe9;
    border-radius: 12px;
    background: #f8fafc;
    box-shadow: 0 12px 28px rgba(15, 23, 42, 0.09);
    transition: transform 0.18s ease, box-shadow 0.18s ease;
  }

  .lotto-explainer-link:hover img {
    transform: translateY(-3px);
    box-shadow: 0 16px 34px rgba(15, 118, 110, 0.16);
  }
`;

export const BottomCta = styled.div`
  display: grid;
  box-sizing: border-box;
  justify-items: center;
  gap: 14px;
  max-width: 820px;
  margin: 36px auto 0;
  padding: 22px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  text-align: center;

  p {
    margin: 0;
    color: #475569;
    line-height: 1.7;
  }

  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 46px;
    padding: 0 18px;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 999px;
    background: #172033;
    color: #ffffff;
    font-weight: 900;
    text-decoration: none;
    transition: background 0.18s ease, transform 0.18s ease;

    &:hover {
      background: #0f766e;
      transform: translateY(-2px);
    }
  }

  @media (max-width: 420px) {
    padding: 18px;

    a {
      width: 100%;
      padding: 0 14px;
      white-space: normal;
      text-align: center;
    }
  }
`;

export const StyledLink = styled.a`
  color: #334155;
  text-decoration: dotted underline;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #0f766e;
  }
`;

export const ScrollTopButton = styled.button`
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.94);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.16);
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    width: 42px;
    height: 42px;
  }
`;

export const CtaButton = styled.a`
  width: 90%;
  max-width: 100%;
  box-sizing: border-box;
  min-height: 64px;
  margin: 1.5rem auto;
  border: 2px solid #c7b5ff;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-weight: 700;
  font-size: 1.05rem;
  color: #7a5bc7;
  text-decoration: none;
  background: transparent;
  transition: all 0.25s ease;
  padding: 0.8rem 1rem;

  &:hover {
    background: #c7b5ff;
    color: #ffffff;
  }

  @media (max-width: 420px) {
    width: 100%;
    min-height: 56px;
    padding: 0.75rem 0.85rem;
    font-size: 1rem;
  }
`;

export const BlogTable = styled.table`
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-collapse: collapse;
  margin: 2rem 0;
  font-size: 1rem;
  table-layout: fixed;

  caption {
    text-align: left;
    font-weight: 700;
    margin-bottom: 0.8rem;
    color: #444;
  }

  th,
  td {
    border: 1px solid #e6ddff;
    padding: 12px;
    text-align: left;
    vertical-align: top;
    overflow-wrap: anywhere;
  }

  th {
    background: #f4f0ff;
    color: #3a2a5f;
  }
`;
